import React, { Component } from "react";
class ConnectionException extends Component {
  state = {};
  render() {
    return <div></div>;
  }
}

export default ConnectionException;
